module.exports = __webpack_public_path__ + "assets/img/teacher (44).bf7f2eb4.png";